var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(String(_vm.status)==='10')?_c('el-tag',{attrs:{"size":"mini","type":"primary"}},[_vm._v("待确认")]):(String(_vm.status)==='20')?_c('el-tag',{attrs:{"size":"mini","type":"warning"}},[_vm._v("已确认")]):(String(_vm.status)==='200')?_c('el-tag',{attrs:{"size":"mini","type":"danger"}},[_vm._v("已完成")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }